export const PAGE_HEADER_TYPE_HERO_WITH_SIDE_IMAGE = 'heroWithSideImage';
